import Layout from "../../../components/layout/layout.js";

import CalendarHome from "../../../components/calendarHome/index.js";

function CalendarHomepage({ component, ...rest }) {
  return <Layout Component={CalendarHome} controlsDisabled={true} {...rest} />;
}

export default CalendarHomepage;
